import moment from "moment";

const isEmpty = (value) =>
  value === undefined || value === null || value === "" ||
  (Array.isArray(value) && value.length === 0);

const optionFilters = new Set([
  "ticket_status_name", "ticket_status", "ticket_type_id", "team_id", "typeView", "type_option",
]);

// Keep form values in state; serialize them only when making an API request.
export const mergeListFilters = (previous = {}, changes = {}) => {
  const filters = { ...previous, ...changes };
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (typeof value === "string") filters[key] = value.trim();
    const isAll = optionFilters.has(key) && (
      filters[key] === "all" || filters[key] === "-1" || filters[key] === -1 ||
      (Array.isArray(value) && value.includes("all"))
    );
    if (isEmpty(filters[key]) || isAll) {
      delete filters[key];
    }
  });
  return filters;
};

export const ticketFilterParams = (filters, statusById = false) => {
  const params = mergeListFilters({}, filters);
  ["duedate", "created"].forEach((key) => {
    if (!params[key]) return;
    if (Array.isArray(params[key])) {
      const range = params[key];
      delete params[key];
      delete params[`${key}_from`];
      delete params[`${key}_to`];
      if (range.length === 2 && range.every((date) => date && moment(date).isValid())) {
        params[`${key}_from`] = moment(range[0]).format("YYYY-MM-DD");
        params[`${key}_to`] = moment(range[1]).format("YYYY-MM-DD");
      }
    } else if (moment(params[key]).isValid()) {
      params[key] = moment(params[key]).format("YYYY-MM-DD");
    } else {
      delete params[key];
    }
  });
  if (Array.isArray(params.team_id)) params.team_id = params.team_id.join(",");
  if (statusById && params.ticket_status_name !== undefined) {
    const status = Number(params.ticket_status_name);
    delete params.ticket_status_name;
    if (Number.isFinite(status)) params.ticket_status = status;
  }
  return params;
};

export const applyTicketFilters = (component, changes, storageKey) => {
  component.setState((state) => {
    const paramsSearch = mergeListFilters(state.paramsSearch, changes);
    return {
      paramsSearch,
      pagination: { ...state.pagination, current: 1, page: 1 },
    };
  }, () => {
    const { pagination, paramsSearch, sortedInfo } = component.state;
    if (storageKey) sessionStorage.setItem(storageKey, JSON.stringify(paramsSearch));
    component.fetchTicketListAPI({
      ...paramsSearch,
      page: 1,
      page_size: pagination.pageSize,
      columnSort: (sortedInfo && sortedInfo.field) || "id",
      typeSort: (sortedInfo && sortedInfo.order) || "descend",
    });
  });
};

export const readListFilters = (storageKey) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey));
    return saved && typeof saved === "object" && !Array.isArray(saved)
      ? mergeListFilters({}, saved) : {};
  } catch {
    return {};
  }
};
